import styled from 'styled-components';

import media from '../../styles/media.style';
import { TEXT_GRAY, BG_GRAY, SCREEN_LOCKUP_WIDTH } from '../../styles/variables.style';

export const Section = styled.section`
  &.stylePage {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    overflow-x: hidden;
    width: ${({ screenSizeExact }) => screenSizeExact}px};
    margin: auto;

    ${media.tabletL`
      padding: 0 0 26px 0;
    `};
  }

  display: flex;
  flex-direction: column;
  padding: 40px 0 80px;
  width: 100%;
  max-width: ${SCREEN_LOCKUP_WIDTH}px;
  margin: 0 auto;
  overflow: hidden;

  ${media.tabletL`
    padding: 60px 0 100px;
  `};
`;

export const Title = styled.h5`
  position: relative;
  text-transform: uppercase;
  font-weight: 600;
  font-size: 16px;
  margin: 0 0 60px;
  color: ${TEXT_GRAY.COMMON_5};
  text-align: center;

  &::after {
    content: '';
    position: absolute;
    bottom: -18px;
    left: 50%;
    transform: translateX(-50%);
    background-color: ${BG_GRAY.COMMON_8};
    height: 3px;
    width: 40px;
  }
`;

export const RelatedProductsContainer = styled.div`
  color: ${TEXT_GRAY.COMMON_5};
  margin: 0 auto;
  max-width: calc(100% - 80px);
  position: relative;
  text-align: center;
  width: ${({ items }) => `${items * 300}px`};
`;

export const ProductSlide = styled.div`
  margin: 0 auto;
  max-width: 300px;
  padding: 0 20px;
  position: relative;
  width: auto;

  &::after {
    display: ${({ isLast }) => (isLast ? 'none' : 'block')};
    position: absolute;
    content: '';
    right: -1px;
    top: 0;
    height: 100%;
    width: 2px;
    background-color: ${BG_GRAY.COMMON_5};
  }
`;

export const ImageWrapper = styled.div`
  width: 100%;
  height: 140px;
  margin: 0 0 20px;

  ${media.tabletL`
    width: 160px;
    height: 160px;
    margin: 0 auto 20px;
  `};
`;

export const CategoryText = styled.p`
  font-size: 12px;
  margin-bottom: 0.5em;
  text-transform: uppercase;
  font-weight: 400;
`;

export const RangeText = styled.p`
  font-size: 18px;
  line-height: 23px;
  margin: 0;
`;

export const ProductNameText = styled.p`
  align-items: center;
  display: flex;
  font-size: 20px;
  justify-content: center;
  line-height: 23px;
  margin: 0;
  min-height: 50px;
  text-transform: uppercase;
`;

export const CTA = styled.p`
  color: #000;
  font-size: 12px;
  margin-top: 2em;
  text-decoration: underline;
  text-transform: uppercase;
  width: 100%;

  & > span {
    font-weight: 800;
  }

  ${media.tabletL`
    font-size: 14px;
  `};
`;



// WEBPACK FOOTER //
// ./src/components/ProductRecommendation/ProductRecommendation.style.js